import React from "react";
import { connect, useDispatch } from "react-redux";
import withReduxProvider from "web/react/redux-provider";
import { gettext } from "web/script/modules/django-i18n";
import browser from "web/script/utils/browser";
import globals from "web/script/modules/globals";
import AppStoreDetails from "web/react/components/app-store-details/app-store-details";
import SearchAndCompare from "web/react/components/search-and-compare/search-and-compare";
import AppDownloadBadge from "web/react/components/app-download-badge/app-download-badge";
import analytics from "web/script/analytics/analytics";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import Button from "web/react/components/button/button";
import backgroundVideo from "./background.mp4";
import styles from "./styles.css";

export function ToAppPage(): JSX.Element {
    const dispatch = useDispatch();
    let title = gettext("app_landing.title");

    if (browser.android) {
        title = gettext("app_landing.android_mobile.title");
    }

    function scanQrCode(e): void {
        e.preventDefault();
        dispatch(
            openCustomerCaptureOverlay({
                captureType: "qr_code",
            })
        );
    }

    function redirectToSignUp(e): void {
        e.preventDefault();
        analytics.event("android_app_registration", "click");
        globals.window.location.href = "/account/register/?android_signup=true";
    }

    return (
        <div className={styles.appToPageWrapper}>
            <video playsInline autoPlay muted loop className={styles.backgroundVideo}>
                <source src={backgroundVideo} type="video/mp4" />
            </video>
            <div className={styles.backgroundImage} />
            <div className={styles.toAppCallToAction}>
                <h1>{title}</h1>
                {!browser.android && <AppStoreDetails />}
                <AppDownloadBadge
                    color="black"
                    appDownloadLink="appTeaser"
                    eventLabel="desktop_web_to_app_download"
                    isButton={true}
                    buttonText={gettext("app_landing.download_free.button")}
                />
                <a href="#" onClick={scanQrCode} className={styles.scanQrLink}>
                    {gettext("app_landing.scan_qr.link")}
                    <SVGIcon name="qr-icon" />
                </a>
                <div className={styles.androidSection}>
                    <span>{gettext("app_landing.android.title")}</span>
                    <a onClick={redirectToSignUp} className={styles.androidLink}>
                        {gettext("app_landing.android.link")}
                    </a>
                </div>
            </div>
            <div className={styles.toAppAnimation}>
                <SearchAndCompare />
            </div>
            <div className={styles.downloadAppMobilePanel}>
                {browser.android ? (
                    <Button
                        styleType="cta"
                        onClick={redirectToSignUp}
                        className={styles.androidButton}
                    >
                        {gettext("app_landing.android_mobile.cta")}
                    </Button>
                ) : (
                    <AppDownloadBadge
                        color="black"
                        appDownloadLink="appPage"
                        eventLabel="mobile_web_to_app_download"
                        isButton={true}
                        buttonText={gettext("app_landing.download_free.button")}
                    />
                )}
            </div>
        </div>
    );
}

export default withReduxProvider(connect(null)(ToAppPage));
